import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import { AxiosResponse } from 'axios'
import TaskDelete from '../TaskDelete/TaskDelete.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { KFormCheckbox } from '@kwixeo/form-vue'
import { BRow, BCol, BButton, BBadge, BAvatar, VBTooltip } from 'bootstrap-vue'
import { emitter, moment } from '@kwixeo/interface-vue'

@Component({
  computed: {
    ...mapGetters('user', ['teamConfigs', 'teamUser'])
  },
  methods: {
    ...mapActions('dynamicModals', ['openModal'])
  },
  components: {
    TaskDelete,
    FontAwesomeIcon,
    KFormCheckbox,
    BRow, BCol, BButton, BBadge, BAvatar
  },
  directives: {
    'b-tooltip': VBTooltip
  }
})
export default class TaskItem extends Vue {
  teamConfigs!: KwixeoFramework.ConfigAttributes
  teamUser!: KwixeoFramework.TeamUser

  @Prop({ required: true, default: () => ({}) }) value!: KwixeoTasks.Task
  @Prop({ default: true }) showStatus!: boolean

  localValue: KwixeoTasks.TaskForm = {
    category: null,
    datetime: null,
    elements: [],
    notes: '',
    priority: undefined,
    status: undefined,
    team_users: [],
    title: ''
  }

  private savingState = false
  private deleteTask = false

  get datetime (): string|null {
    const datetime = this.localValue.datetime
    if (!datetime) {
      return null
    }

    const m = moment(datetime)
    let format = this.teamConfigs.date_format
    if (m.hours() !== 0 || m.minutes() !== 0) {
      format += ' [à] HH[h]mm'
    }
    return moment(datetime).format(format)
  }

  get teamUsers (): KwixeoFramework.TeamUsers {
    return this.localValue.team_users ? this.localValue.team_users.filter(user => user.id !== this.teamUser.id) : []
  }

  @Watch('value', { immediate: true })
  watchValue (value: KwixeoTasks.Task): void {
    this.setLocalValue(value)
  }

  updateTask (response: AxiosResponse, propagate = true): void {
    this.localValue = response.data
    this.$emit('input', this.localValue, propagate)
  }

  private setLocalValue (value: KwixeoTasks.Task): void {
    this.localValue = JSON.parse(JSON.stringify(value))
  }

  private getElementLabel (element: KwixeoTasks.TaskElement): string|undefined {
    switch (element.type) {
      case 'customer':
        return element.data.name
      case 'contact':
        return element.data.fullname
      default:
        return element.title
    }
  }

  private getElementLink (element: KwixeoTasks.TaskElement): KwixeoInterface.GenericObject {
    let name
    let type
    switch (element.type) {
      case 'customer':
        name = 'contacts-customer-item'
        if (element.data.reference.customer) type = 'customer'
        else if (element.data.reference.prospect) type = 'prospect'
        else if (element.data.reference.provider) type = 'provider'
        else if (element.data.reference.subcontractor) type = 'subcontractor'
        break
      case 'contact':
        name = 'contacts-contact-item'
        break
      case 'opportunity':
        name = 'opportunity-item'
        break;
      case 'providerCommand':
        name = 'stock-command-item'
        break;
      case 'quotation':
        name = 'quotation-item'
        break;
      case 'command':
        name = 'command-item'
        break;
      case 'delivery':
        name = 'delivery-item'
        break;
      case 'proforma':
        name = 'proforma-item'
        break;
      case 'invoice':
        name = 'invoice-item'
        break;
      case 'credit':
        name = 'credit-item'
        break;
      case 'charge':
        name = 'charges-item'
        break;
      case 'contract':
        name = 'contract-item'
        break;
    }

    return {
      name: name,
      params: {
        id: element.id,
        type
      }
    }
  }

  private async changeStatus (status: boolean): Promise<void> {
    this.savingState = true
    await this.$kwTasks.axios.put('/task/' + this.localValue.id + '?with_file=true', {
      status: status ? 4 : 1
    })
      .then(response => {
        emitter.emit('taskUpdated', {
          old: JSON.parse(JSON.stringify(this.value)),
          new: response.data
        })
        this.updateTask(response)
      })
      .catch(error => {
        throw new Error(error)
      })
      .finally(() => {
        this.savingState = false
      })
  }
}
